import Image from 'next/image';
import React, { FC } from 'react';

import { IFeaturedItem } from '@/contentful/utils/featuredItem';

import IconMark from './assets/icon-mark.svg';

import styles from './part-feature-case-item.module.scss';

// TODO: update this interface
 interface IPartFeatureCaseItem {
  contentItem: IFeaturedItem;
}

const PartFeatureCaseItem: FC<IPartFeatureCaseItem> = ({ contentItem }) => (
  <>
    <div className={styles.featureItemIconWrap}>
      <Image
        src={contentItem.icon?.src ?? ''}
        alt={contentItem.icon?.alt ?? ''}
        width={contentItem.icon?.width ?? 0}
        height={contentItem.icon?.height ?? 0}
      />
    </div>
    <div className={styles.featureItemContainer}>
      <h3 className={styles.featureItemTitle}>{contentItem.title}</h3>
      <div className={styles.featureContentWrap}>
        {contentItem.description && (
        <p className={styles.featureText}>{contentItem.description}</p>
        )}
        {contentItem.list && (
        <ul className={styles.featureContentList}>
          {contentItem.list.map((item: string) => (
            <li key={item} className={styles.featureContentItem}>
              <IconMark />
              <span className={styles.featureText}>{item}</span>
            </li>
          ))}
        </ul>
        )}
      </div>
    </div>
  </>
);

export default PartFeatureCaseItem;
